import { Link } from 'react-router-dom';
import { cn } from '@/lib/utils';

export function SectionLabel({ children, className = '', dark = false }) {
  return (
    <span
      className={cn(
        'eyebrow inline-flex items-center',
        dark ? 'text-[#C9A775]' : 'text-brand-accent',
        className
      )}
      data-testid="section-label"
    >
      {children}
    </span>
  );
}

export function PrimaryButton({ to, href, children, onClick, className = '', testId, type = 'button' }) {
  const base =
    'group inline-flex items-center gap-2 bg-brand-primary text-brand-background px-6 py-3 text-sm font-medium tracking-wide transition-colors duration-200 hover:bg-brand-secondary';
  const arrow = (
    <span className="inline-block transition-transform duration-200 group-hover:translate-x-1" aria-hidden="true">
      →
    </span>
  );
  if (to) {
    return (
      <Link to={to} className={cn(base, className)} data-testid={testId}>
        {children}
        {arrow}
      </Link>
    );
  }
  if (href) {
    return (
      <a href={href} className={cn(base, className)} data-testid={testId}>
        {children}
        {arrow}
      </a>
    );
  }
  return (
    <button type={type} onClick={onClick} className={cn(base, className)} data-testid={testId}>
      {children}
      {arrow}
    </button>
  );
}

export function OutlineButton({ to, children, onClick, className = '', testId }) {
  const base =
    'group inline-flex items-center gap-2 border border-brand-accent text-brand-accent px-5 py-2.5 text-sm font-medium tracking-wide transition-colors duration-200 hover:bg-brand-accent hover:text-white';
  const arrow = (
    <span className="inline-block transition-transform duration-200 group-hover:translate-x-1" aria-hidden="true">
      →
    </span>
  );
  if (to) {
    return (
      <Link to={to} className={cn(base, className)} data-testid={testId}>
        {children}
        {arrow}
      </Link>
    );
  }
  return (
    <button type="button" onClick={onClick} className={cn(base, className)} data-testid={testId}>
      {children}
      {arrow}
    </button>
  );
}

export function TextLink({ to, href, children, className = '', testId }) {
  const cls = cn('link-underline text-brand-primary font-medium', className);
  if (to) {
    return (
      <Link to={to} className={cls} data-testid={testId}>
        {children}
      </Link>
    );
  }
  return (
    <a href={href} className={cls} data-testid={testId}>
      {children}
    </a>
  );
}
